import React from "react";

const TermsOfUse = () => {
  return (
    <div className="bg-gray-100 min-h-screen pt-24 px-4 sm:px-6 lg:px-8 flex justify-center">
      <div className="max-w-4xl w-full bg-white shadow-lg rounded-2xl p-6 sm:p-10 mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-gray-800">
          Terms of Use
        </h1>

        <p className="mb-4 text-gray-700 text-base sm:text-lg leading-relaxed">
          Welcome to Carmie! By accessing or using our website and mobile app,
          you agree to comply with these Terms of Use. Please read them
          carefully before using our services.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Use of Services
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Carmie provides a platform connecting vehicle owners with mechanics.
          You agree to use the platform responsibly and not engage in any
          activity that violates applicable laws or harms other users.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Account Responsibilities
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Users are responsible for maintaining the confidentiality of their
          account information. You agree to notify us immediately of any
          unauthorized use of your account.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Payment and Transactions
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Payments for services rendered via Carmie are handled through our
          integrated payment system. Users agree to provide accurate billing
          information and comply with all applicable payment regulations.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Prohibited Conduct
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Users may not misuse the platform, submit false information, attempt
          unauthorized access, or engage in any harmful behavior toward other
          users or the system.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Limitation of Liability
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Carmie is not liable for any direct or indirect damages arising from
          the use of the platform, including service delays, errors, or disputes
          between users.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Modifications to Terms
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          We may update these Terms of Use periodically. Continued use of the
          platform constitutes acceptance of any changes.
        </p>

        <p className="mt-8 text-gray-600 text-sm text-center">
          If you have any questions about these Terms, please contact us at{" "}
          <a
            href="mailto:customercare@carmie.biz"
            className="text-green-600 hover:underline"
          >
            customercare@carmie.biz
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;

// import React from "react";

// const TermsOfUse = () => {
//   return (
//     <div className="flex justify-center px-4 sm:px-6 lg:px-8 mt-20 bg-gray-100 min-h-screen">
//       <div className="max-w-4xl w-full bg-white shadow-lg rounded-2xl p-6 sm:p-10">
//         <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-gray-800">
//           Terms of Use
//         </h1>

//         <p className="mb-4 text-gray-700 text-base sm:text-lg leading-relaxed">
//           Welcome to Carmie! By accessing or using our website and mobile app,
//           you agree to comply with these Terms of Use. Please read them
//           carefully before using our services.
//         </p>

//         <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
//           Use of Services
//         </h2>
//         <p className="mb-4 text-gray-700 leading-relaxed">
//           Carmie provides a platform connecting vehicle owners with mechanics.
//           You agree to use the platform responsibly and not engage in any
//           activity that violates applicable laws or harms other users.
//         </p>

//         <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
//           Account Responsibilities
//         </h2>
//         <p className="mb-4 text-gray-700 leading-relaxed">
//           Users are responsible for maintaining the confidentiality of their
//           account information. You agree to notify us immediately of any
//           unauthorized use of your account.
//         </p>

//         <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
//           Payment and Transactions
//         </h2>
//         <p className="mb-4 text-gray-700 leading-relaxed">
//           Payments for services rendered via Carmie are handled through our
//           integrated payment system. Users agree to provide accurate billing
//           information and comply with all applicable payment regulations.
//         </p>

//         <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
//           Prohibited Conduct
//         </h2>
//         <p className="mb-4 text-gray-700 leading-relaxed">
//           Users may not misuse the platform, submit false information, attempt
//           unauthorized access, or engage in any harmful behavior toward other
//           users or the system.
//         </p>

//         <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
//           Limitation of Liability
//         </h2>
//         <p className="mb-4 text-gray-700 leading-relaxed">
//           Carmie is not liable for any direct or indirect damages arising from
//           the use of the platform, including service delays, errors, or disputes
//           between users.
//         </p>

//         <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
//           Modifications to Terms
//         </h2>
//         <p className="mb-4 text-gray-700 leading-relaxed">
//           We may update these Terms of Use periodically. Continued use of the
//           platform constitutes acceptance of any changes.
//         </p>

//         <p className="mt-8 text-gray-600 text-sm text-center">
//           If you have any questions about these Terms, please contact us at{" "}
//           <a
//             href="mailto:support@carmie.biz"
//             className="text-green-600 hover:underline"
//           >
//             support@carmie.biz
//           </a>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default TermsOfUse;
